import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { Router } from '@angular/router';
import { AccessMethod } from '../model/accessMethod';
import { UserService } from '../service/user.service';
import { Log } from '../util/log';
import { DateAdapter } from "@angular/material/core";
import { DateHelper } from "../util/dateHelper";
import { NewUserRequest } from '../model/newUserRequest';
import { NewUserRequestResult } from '../model/NewUserRequestResult';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Overlay } from "@angular/cdk/overlay";
import { EmailData } from '../model/EmailData';
import { UploadedFile } from '../model/UploadedFile';



@Component({
  selector: 'app-view-request-dialog',
  templateUrl: './view-request-dialog.component.html',
  styleUrls: ['./view-request-dialog.component.css']
})
export class ViewRequestDialogComponent implements OnInit {

  @ViewChild('dialogLoader', { static: true }) loader;

  // Expose Object to template for Object.keys()
  Object = Object;

  request: NewUserRequest;

  fromFormControl: FormControl;
  toFormControl: FormControl;

  startDate: string;
  expirationDate: string;

  startDateDate: Date;
  expirationDateDate: Date;

  startDateString: String = "";
  expirationDateString: String = "";

  error: boolean = false;
  errorMessage: string = "";

  displayPhoneNumber: string;

  acceptRejectNotes: string = "";

  accepted: boolean;

  closeDialogString = $localize`:@@request_view_dialog_close_toast:Chiudi`;

  acceptString = $localize`:@@request_view_dialog_confirm_continue:Sì, procedi`;

  cancelString = $localize`:@@request_view_dialog_confirm_cancel:No, annulla`;

  warningString = $localize`:@@request_view_dialog_warning:Attenzione`;

  //per uso mio
  requestPending: boolean;


  ownerEmail: string = "";
  ownerDisplayName; string = "";

  amIAlias: boolean;

  hasDocuments: boolean = false;

  // Dynamic file mapping keyed by file description
  documentFiles: { [key: string]: UploadedFile } = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public input: any,
    public dialog: MatDialog,
    private userService: UserService,
    private router: Router,
    private formBuilder: FormBuilder,
    private dateAdapter: DateAdapter<any>,
    public dialogRef: MatDialogRef<ViewRequestDialogComponent>,
    private snackBar: MatSnackBar,
    private overlay: Overlay


  ) {

    this.request = input.data;


    Log.debug("\n\n\nthis.request: ");
    Log.debug(this.request);

    this.amIAlias = input.isUserAlias;

    Log.debug("\n\n\namIAlias: ");
    Log.debug(this.amIAlias);

    this.displayPhoneNumber = this.request.prefix + " " + this.request.phoneNumber;

    this.dateAdapter.setLocale($localize`:@@request_view_dialog_datepicker_locale:it`);

    if (this.request.documents) {

      this.hasDocuments = true;

      Log.debug("\nthis.request.documents: ");
      Log.debug(this.request.documents);

      // Map documents by their description
      this.documentFiles = {};
      for (const file of this.request.documents) {
        this.documentFiles[file.description] = file;
      }

      Log.debug("\nthis.documentFiles: ");
      Log.debug(this.documentFiles);

    } else {
      this.hasDocuments = false;
    }

    if (!this.request.rejected && !this.request.accepted) {

      this.requestPending = true;

      if (this.request.startDate !== null && this.request.startDate !== undefined) {
        this.startDateDate = this.request.startDate;
        this.fromFormControl = new FormControl(this.startDateDate);

      } else {
        this.startDate = DateHelper.formatDateRFC3339(new Date());
        this.fromFormControl = new FormControl(this.startDate);

      }

      if (this.request.expirationDate !== null && this.request.expirationDate !== undefined) {
        this.expirationDateDate = this.request.expirationDate;
        this.toFormControl = new FormControl(this.expirationDateDate);
      } else {
        let oneMonthDate = new Date();
        oneMonthDate.setMonth(oneMonthDate.getMonth() + 1);

        this.expirationDate =
          DateHelper.formatDateRFC3339(oneMonthDate);
        this.toFormControl = new FormControl(this.expirationDate);

      }

    } else {

      this.requestPending = false;

      // this.startDate = DateHelper.formatDateFriendly(new Date(this.request.startDate));
      // this.expirationDate = DateHelper.formatDateFriendly(new Date(this.request.expirationDate));
      this.startDate = DateHelper.formatDateFriendly(this.request.startDate);
      this.expirationDate = DateHelper.formatDateFriendly(this.request.expirationDate);


      Log.debug("\n\n\nthis.startDate: ");
      Log.debug(this.startDate);

      Log.debug("\nthis.expirationDate: ");
      Log.debug(this.expirationDate);
    }


  }

  ngOnInit(): void {

    this.loader.hideLoading();
  }

  ngAfterViewInit() {
    this.ownerEmail = this.userService.meUser.email;
    this.ownerDisplayName = this.userService.meUser.displayName;
  }

  closeDialog(result) {
    this.dialogRef.close(result);
  }

  openFile(fileDescription): void {
    Log.debug("openFile clicked with fileDescription: " + fileDescription);

    const file = this.documentFiles[fileDescription];
    if (file && file.fileUrl) {
      window.open(file.fileUrl, '_blank');
    } else {
      Log.debug("Nessun file corrispondente trovato.");
    }
  }

  checkData(accepted) {

    let from: Date;
    from = new Date(this.fromFormControl.value);
    from.setHours(0);
    from.setMinutes(0);
    from.setSeconds(0);
    from.setMilliseconds(0);

    let to: Date;
    to = new Date(this.toFormControl.value);
    to.setHours(23);
    to.setMinutes(59);
    to.setSeconds(59);
    to.setMilliseconds(0);

    this.startDate = DateHelper.formatDateRFC3339(from);
    this.expirationDate = DateHelper.formatDateRFC3339(to);
    this.startDateDate = from;
    this.expirationDateDate = to;

    Log.debug("in check data");

    this.error = false;

    if (accepted == false && this.acceptRejectNotes.length < 2) {
      Log.debug("missing notes");
      this.errorMessage = $localize`:@@request_view_dialog_notes_missing:È necessario inserire un messaggio per rifiutare la richiesta`;
      this.error = true;
      return false;
    }


    if (from >= to || to <= new Date()) {
      Log.debug("dates error");
      this.errorMessage = $localize`:@@request_view_dialog_invalid_dates:Le date inserite non sono valide`;
      this.error = true;
      return false;
    }

    Log.debug(to.getFullYear());

    if (to.getFullYear() > 2100) {
      Log.debug("end date too far");
      this.errorMessage = $localize`:@@request_view_dialog_invalid_end_date:La data di scadenza non deve superare l'anno 2100`;
      this.error = true;
      return false;
    }

    return true;
  }

  acceptRequest() {
    Log.debug("acceptRequest clicked");

    //true = data OK
    if (this.checkData(true)) {
      let message = $localize`:@@request_view_dialog_accept_confirm:Desideri accettare la richiesta?`;
      let confirmMessage = this.acceptString;
      let cancelMessage = this.cancelString;

      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: "350px",
        data: { message, confirmMessage, cancelMessage },
        scrollStrategy,
      });

      dialogRef.afterClosed().subscribe((response) => {
        if (response) {
          this.accepted = true;
          this.sendRequestApproval();
        }
      });
    }
  }

  rejectRequest() {
    Log.debug("rejectRequest clicked");

    //true = data OK
    if (this.checkData(false)) {
      let message = $localize`:@@request_view_dialog_reject_confirm:Desideri rifiutare la richiesta?`;
      let confirmMessage = this.acceptString;
      let cancelMessage = this.cancelString;

      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: "350px",
        data: { message, confirmMessage, cancelMessage },
        scrollStrategy,
      });

      dialogRef.afterClosed().subscribe((response) => {
        if (response) {
          this.accepted = false;
          this.sendRequestApproval();
        }
      });
    }
  }

  sendRequestApproval() {
    this.loader.showLoading();

    let result: NewUserRequestResult = new NewUserRequestResult();
    result.accepted = this.accepted;

    result.startDate = this.startDate;
    result.expirationDate = this.expirationDate;
    result.startDateDate = this.startDateDate;
    result.expirationDateDate = this.expirationDateDate;

    if (this.accepted) {
      result.acceptRejectNotes = this.request.alias.publicName + ": " + this.acceptRejectNotes;
    } else {
      result.acceptRejectNotes = this.acceptRejectNotes;
    }

    Log.debug("\nresult: ");
    Log.debug(result);

    Log.debug("\nthis.request.id.toString(): ");
    Log.debug(this.request.id.toString());


    this.userService.sendRequestApproval(result, this.request.id.toString()).subscribe((sendRequestApprovalResponse) => {

      Log.debug("\nsendRequestApproval: ");
      Log.debug(sendRequestApprovalResponse);

      if (this.accepted) {
        let snackBarRef = this.snackBar.open($localize`:@@request_view_dialog_request_accepted_success:Richiesta accettata con successo`, this.closeDialogString, {
          duration: 3000,
          panelClass: ['green-snackbar']
        });
      } else {
        let snackBarRef = this.snackBar.open($localize`:@@request_view_dialog_request_rejected_success:Richiesta rifiutata con successo`, this.closeDialogString, {
          duration: 3000,
          panelClass: ['green-snackbar']
        });
      }



      let emailToSendData = new EmailData();

      let confirmMessage: string = $localize`:@@request_view_dialog_email_content_1:La tua richiesta di transito effettuata a:` + " " + this.ownerDisplayName + " ";

      if (this.accepted) {

        confirmMessage += $localize`:@@request_view_dialog_email_content_2_accepted:è stata accettata`;
      } else {

        confirmMessage += $localize`:@@request_view_dialog_email_content_2_rejected:è stata rifiutata`;
      }

      if (this.acceptRejectNotes != "") {
        confirmMessage += "<br>"

        confirmMessage += $localize`:@@request_view_dialog_email_content_3_operator_notes:Messaggio operatore:` + " " + this.acceptRejectNotes;
      }

      emailToSendData.message = confirmMessage;


      emailToSendData.subject = $localize`:@@request_view_dialog_email_subject:Aggiornamento stato richiesta transito`;


      // emailToSendData.fromEmail = "admin@1control.it";
      emailToSendData.fromEmail = "noreply@pilomat.com";

      // let aliasEmailDomain = this.request.alias.alias.email.split("@")[1];
      // let noreplyAtaliasEmailDomain = "noreply@" + aliasEmailDomain;
      // emailToSendData.ccEmail = noreplyAtaliasEmailDomain;

      emailToSendData.ccEmail = this.request.alias.alias.email;


      emailToSendData.fromName = this.ownerDisplayName;
      emailToSendData.toEmail = this.request.email;

      emailToSendData.replyToEmail = "noreply@pilomat.com";


      this.userService.sendEmail(emailToSendData).subscribe((response) => {

        Log.debug("\sendEmail response: ");
        Log.debug(response);

        setTimeout(() => {
          this.closeDialog(sendRequestApprovalResponse)
          this.loader.hideLoading();
        }, 250);

      }, (err) => {


        Log.debug("\sendEmail error response: ");
        Log.debug(err);


        let message = $localize`:@@request_view_dialog_send_email_error:Abbonamento creato con successo, ma è stato riscontrato un errore nell'invio della mail di conferma`;
        let header = this.warningString;

        const scrollStrategy = this.overlay.scrollStrategies.reposition();

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: "350px",
          data: { message, header },
          scrollStrategy,
        });

        dialogRef.afterClosed().subscribe((response) => {
          this.loader.hideLoading();
          return;
        });
      });
    }, (err) => {

      Log.debug("\nsendRequestApproval error: ");
      Log.debug(err);

      this.loader.hideLoading();

      if (err == "code-already-used") {
        let message = $localize`:@@request_view_dialog_confirm_code_already_used_error:Impossibile accettare la richiesta, uno dei metodi d'accesso è già in uso da parte di un altro utente esistente.`;
        let header = this.warningString;

        const scrollStrategy = this.overlay.scrollStrategies.reposition();

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: "350px",
          data: { message, header },
          scrollStrategy,
        });

        dialogRef.afterClosed().subscribe((response) => {
          this.loader.hideLoading();
          return;
        });
      } else
        if (err.startsWith("code-already-used")) {
          let message = $localize`:@@request_view_dialog_confirm_code_already_used_error_with_method:Impossibile accettare la richiesta, il seguente metodo d'accesso è già in uso da parte di un altro utente esistente:`;
          message += " " + err.match(/^code-already-used (.+)$/)?.[1] || null;
          let header = this.warningString;

          const scrollStrategy = this.overlay.scrollStrategies.reposition();

          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: "350px",
            data: { message, header },
            scrollStrategy,
          });

          dialogRef.afterClosed().subscribe((response) => {
            this.loader.hideLoading();
            return;
          });
        } else if (err == "invalid-user") {
          let message = $localize`:@@request_view_dialog_confirm_invalid_user_error:Impossibile accettare la richiesta, i dati inseriti sono in uso da parte di un utente esistente.`;
          let header = this.warningString;

          const scrollStrategy = this.overlay.scrollStrategies.reposition();

          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: "350px",
            data: { message, header },
            scrollStrategy,
          });

          dialogRef.afterClosed().subscribe((response) => {
            this.loader.hideLoading();
            return;
          });
        } else {
          let snackBarRef = this.snackBar.open($localize`:@@request_view_dialog_request_accept_reject_error:Si è verificato un errore nell'invio dell'approvazione, riprovare più tardi`, this.closeDialogString, {
            duration: 5000,
            panelClass: ['red-snackbar']
          });
        }
    });
  }


  deleteRequest() {
    let message = $localize`:@@request_view_dialog_confirm_delete_extended_request:Sei sicuro di voler eliminare la richiesta? (Questa operazione non eliminerà l'abbonamento corrispondente)`;
    let confirmMessage = this.acceptString;
    let cancelMessage = this.cancelString;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.userService.deleteTransmitRequest(this.request.id).subscribe((response) => {

          this.loader.hideLoading();
          setTimeout(() => {
            // window.location.reload();
            this.closeDialog("Deleted");
          }, 250);

        }, (err) => {
          Log.debug("\ndeleteTransmitRequest error: ");
          Log.debug(err);

          let snackBarRef = this.snackBar.open($localize`:@@request_view_dialog_request_delete_error_message:Si è verificato un errore nell'eliminazione della richiesta, riprovare più tardi`, this.closeDialogString, {
            duration: 5000,
            panelClass: ['red-snackbar']
          });

          this.loader.hideLoading();
        });
      }
    });
  }
}
